import { createReducer } from '@reduxjs/toolkit';
import { getStoreSummaryRequest, getStoreSummarySuccess, getStoreSummaryFailure, selectedStoreRequest, getMerchantIdRequest, getMerchantIdSuccess, getMerchantIdFailure, getSingleStoreDetailsRequest, getSingleStoreDetailsSuccess, getSingleStoreDetailsFailure } from '../actions/storeActions';

const initialState = {
    storeDetailsRows: [],
	storeDetailsRowsError: '',
    selectedStore: null,
    merchantId: null,
	storeUUID:'',
	sourceId: '',
	singleStoreDetailsRowsError: '',
	singleStoreDetailsRows: []
}

const storePageReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(getStoreSummaryRequest, (state, action) => {
            // FOR SAGA
        }).addCase(getStoreSummarySuccess, (state, action) => {
            state.storeDetailsRows = action.payload.data;
        }).addCase(getStoreSummaryFailure, (state, action) => {
            state.storeDetailsRows = { msg: 'ERROR', details:  action };
			state.storeDetailsRowsError = action.payload.error;
        }).addCase(selectedStoreRequest, (state, action) => {
			state.selectedStore = action.payload;
			state.storeUUID = action.payload.storeUUID;
			state.sourceId = action.payload.sourceId;
        }).addCase(getMerchantIdRequest, (state) => {
            //state.merchantId;
        }).addCase(getMerchantIdSuccess, (state, action) => {
            // state.merchantId = action.payload.data;
        }).addCase(getMerchantIdFailure, (state, action) => {
            // state.merchantId = { msg: 'ERROR' };
        })
		.addCase(getSingleStoreDetailsRequest, (state) => {
			state.singleStoreDetailsRows = '';
			state.storeUUID = '';
			state.sourceId = '';
        }).addCase(getSingleStoreDetailsSuccess, (state, action) => {
			//console.log('action getSingleStoreDetailsSuccess', action)
            state.singleStoreDetailsRows = action.payload.data;
			state.singleStoreDetailsRowsError = '';
			state.storeUUID = action.payload.data.uuid;
			state.sourceId = action.payload.data.storeId;
        }).addCase(getSingleStoreDetailsFailure, (state, action) => {
            state.singleStoreDetailsRowsError = action.payload.error;
			state.singleStoreDetailsRows = '';
		})

        builder.addDefaultCase((state) => state); 
});
export default storePageReducer;
